import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { LocalStorageService } from 'ng2-webstorage';
import { Observable } from 'rxjs/Rx';
import { AddUserFirebaseService } from '../../components/manageuser/adduser/adduserfirebase.service';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: '',
    main: [
      {
        id: 1,
        state: 'dashboard',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        id: 2,
        state: 'noticeboardmodule',
        name: 'Noticeboard',
        type: 'sub',
        icon: 'fa fa-edit',
        children: [
          {
            state: 'noticeboard',
            name: 'Compose'
          },
          {
            state: 'outbox',
            name: 'Outbox'
          },]
      },
      {
        id: 3,
        state: 'soundingboard',
        name: 'Sounding Board Inbox',
        type: 'link',
        icon: 'fa fa-comments-o'
      },
      {
        id: 4,
        state: 'calendar',
        name: 'Calendar',
        type: 'link',
        icon: 'fa fa-calendar'
      },
      // {
      //   state: 'forummodule',
      //   name: 'Forum',
      //   type: 'sub',
      //   icon: 'fa fa-calendar',
      //   children: [
      //     {
      //       state: 'forum',
      //       name: 'Forum'
      //     },
      //     {
      //       state: 'outbox',
      //       name: 'OutBox'
      //     },
      //    ]
      // },
      {
        id: 5,
        state: 'manageuser',
        name: 'Manage User',
        type: 'sub',
        icon: 'fa fa-manage-user',
        children: [
          {
            state: 'department',
            name: 'Department/Category'
          },
          {
            state: 'user',
            name: 'User'
          },
          {
            state: 'sectional',
            name: 'sectional'
          }

        ]
      },
      {
        id: 11,
        state: 'parentchild',
        name: 'Student Details',
        type: 'sub',
        icon: 'fa fa-users',
        children: [
          {
            state: 'parentchild',
            name: 'Student Details'
          }
        ]

      },
      // {
      //   id: 6,
      //   state: 'googleClassroom',
      //   name: 'Google Classroom',
      //   type: 'sub',
      //   icon: 'fa fa-manage-user',
      //   children: [{
      //     name: "Classroom Confirmation",
      //     state: "approvalList"
      //   },{
      //   //   name: "Google Classes",
      //   //   state: "coursesList"
      //   // },{
      //     name: "Assignments",
      //     state: "coursesList"
      //   },{
      //     name: "Create Classes",
      //     state: "createClasse",
      //   }]
      // },
      // {
      //   state: 'attendance',
      //   name: 'Attendance',
      //   type: 'sub',
      //   icon: 'fa fa-desktop',
      //   children: [
      //     {
      //       state: 'newattendance',
      //       name: 'New Attendance'
      //     },
      //     {
      //       state: 'attendancereport',
      //       name: 'Attendance Report'
      //     },
      //     {
      //       state: 'studentreport',
      //       name: 'Student Report'
      //     },

      //   ]
      // },
      // {
      //   state: 'parentchild',
      //   name: 'Parent Child',
      //   type: 'sub',
      //   icon: 'fa fa-users',
      //   children: [
      //     {
      //       state: 'parentchild',
      //       name: 'Parent Child'
      //     },
      //   ]
      // },


    ]
  },



];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
  public schoolId: string;
  public userId: string;
  public userUrl: string = "/schooluser/";
  constructor(public localStorage: LocalStorageService, private firebasedb: AngularFireDatabase,) {
    this.getUser();

  }
  public getUser() {

    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.schoolId = this.schoolId;
    this.userId = this.localStorage.retrieve('Id');
    this.firebasedb.object(`${this.schoolId + this.userUrl + this.userId}`).map(items => {

    });
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/shared/menu-items/menu-items.ts